import React from 'react'

export default function LogoBirVpn() {
  return (
    <a class="navbar-brand" href="#">
          <img src="./image/111.png" alt="" width="60" height="50" />
        </a>
  )
}
